<template>
  <div class="mail-body-mailtype">
    <div class="mailtype-list" role="tablist" :aria-label="$t('components.email.folders.label')">
      <div
        class="mailtype mailtype-incoming"
        :class="[selected_folder == 'Inbox' ? 'active' : '']"
        @click="switchMailFolder('Inbox')"
        @keydown.enter="switchMailFolder('Inbox')"
        @keydown.space.prevent="switchMailFolder('Inbox')"
        role="tab"
        tabindex="0"
        :aria-selected="selected_folder == 'Inbox'"
        :aria-label="$t('components.email.folders.received')"
      >
        <div class="mt incoming">
          <svg
            id="Layer_2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 69.64 62.9"
          >
            <defs></defs>
            <g id="Layer_1-2">
              <path
                class="cls-2"
                d="M53.44,15.64H16.2c-.55,0-1,.45-1,1v28.45c0,.55.45,1,1,1h37.25c.55,0,1-.45,1-1v-28.45c0-.55-.45-1-1-1ZM52.44,44.09H17.2v-26.45h35.25v26.45Z"
              />
              <path
                class="cls-2"
                d="M20.73,40.58c.2.22.47.33.74.33.24,0,.48-.09.67-.26l9.5-8.63,2.58,2.34c.19.17.43.26.67.26s.48-.09.67-.26l2.58-2.34,9.5,8.63c.19.17.43.26.67.26.27,0,.54-.11.74-.33.37-.41.34-1.04-.07-1.41l-9.36-8.5,9.36-8.5c.41-.37.44-1,.07-1.41-.37-.41-1-.44-1.41-.07l-12.75,11.58-12.75-11.58c-.41-.37-1.04-.34-1.41.07-.37.41-.34,1.04.07,1.41l9.36,8.5-9.36,8.5c-.41.37-.44,1-.07,1.41Z"
              />
              <rect class="cls-1" width="69.64" height="62.9" />
            </g>
          </svg>
        </div>
        {{ $t('components.email.folders.received') }}
      </div>
      <div
        class="mailtype mailtype-sent"
        :class="[selected_folder == 'SentItems' ? 'active' : '']"
        @click="switchMailFolder('SentItems')"
        @keydown.enter="switchMailFolder('SentItems')"
        @keydown.space.prevent="switchMailFolder('SentItems')"
        role="tab"
        tabindex="0"
        :aria-selected="selected_folder == 'SentItems'"
        :aria-label="$t('components.email.folders.sent')"
      >
        <div class="mt sent">
          <svg
            id="Layer_2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 69.64 62.9"
          >
            <defs></defs>
            <g id="Layer_1-2">
              <path
                class="cls-2"
                d="M52.59,16.22H16.86c-.55,0-1,.45-1,1v3.66c0,.55.45,1,1,1s1-.45,1-1v-2.66h33.73v26.45H17.86v-3.08c0-.55-.45-1-1-1s-1,.45-1,1v4.08c0,.55.45,1,1,1h35.73c.55,0,1-.45,1-1v-28.45c0-.55-.45-1-1-1Z"
              />
              <path
                class="cls-2"
                d="M21.2,41.18c.2.21.46.31.73.31.25,0,.49-.09.69-.27l9.07-8.59,2.43,2.3c.19.18.44.27.69.27s.49-.09.69-.27l2.43-2.3,9.07,8.59c.19.18.44.27.69.27.27,0,.53-.1.73-.31.38-.4.36-1.03-.04-1.41l-8.99-8.51,8.99-8.51c.4-.38.42-1.01.04-1.41-.38-.4-1.01-.42-1.41-.04l-12.19,11.54-12.19-11.54c-.4-.38-1.03-.36-1.41.04-.38.4-.36,1.03.04,1.41l8.99,8.51-8.99,8.51c-.4.38-.42,1.01-.04,1.41Z"
              />
              <path
                class="cls-2"
                d="M17.86,25.71c0-.55-.45-1-1-1H3.32c-.55,0-1,.45-1,1s.45,1,1,1h13.54c.55,0,1-.45,1-1Z"
              />
              <path
                class="cls-2"
                d="M17.86,31.45c0-.55-.45-1-1-1H6.76c-.55,0-1,.45-1,1s.45,1,1,1h10.1c.55,0,1-.45,1-1Z"
              />
              <path
                class="cls-2"
                d="M17.86,37.18c0-.55-.45-1-1-1h-7.14c-.55,0-1,.45-1,1s.45,1,1,1h7.14c.55,0,1-.45,1-1Z"
              />
              <rect class="cls-1" width="69.64" height="62.9" />
            </g>
          </svg>
        </div>
        {{ $t('components.email.folders.sent') }}
      </div>
      <div
        class="mailtype mailtype-all"
        :class="[selected_folder == 'all' ? 'active' : '']"
        @click="switchMailFolder('all')"
        @keydown.enter="switchMailFolder('all')"
        @keydown.space.prevent="switchMailFolder('all')"
        role="tab"
        tabindex="0"
        :aria-selected="selected_folder == 'all'"
        :aria-label="$t('components.email.folders.all_mail')"
      >
        <div class="mt all">
          <svg
            id="Layer_2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 69.64 62.9"
          >
            <defs></defs>
            <g id="Layer_1-2">
              <path
                class="cls-2"
                d="M52.12,17.66H18.63c-.55,0-1,.45-1,1v3.09h-3.09c-.55,0-1,.45-1,1v25.57c0,.55.45,1,1,1h33.48c.55,0,1-.45,1-1v-3.09h3.09c.55,0,1-.45,1-1v-25.57c0-.55-.45-1-1-1ZM47.02,47.33H15.54v-23.57h2.09v20.48c0,.55.45,1,1,1h28.39v2.09ZM51.12,43.24h-31.48v-23.57h31.48v23.57Z"
              />
              <path
                class="cls-2"
                d="M22.63,40.25c.2.22.47.33.74.33.24,0,.48-.09.67-.26l8.47-7.69,2.25,2.04c.19.17.43.26.67.26s.48-.09.67-.26l2.25-2.04,8.47,7.69c.19.17.43.26.67.26.27,0,.54-.11.74-.33.37-.41.34-1.04-.07-1.41l-8.33-7.56,8.33-7.56c.41-.37.44-1,.07-1.41-.37-.41-1-.44-1.41-.07l-11.39,10.35-11.39-10.35c-.41-.37-1.04-.34-1.41.07-.37.41-.34,1.04.07,1.41l8.33,7.56-8.33,7.56c-.41.37-.44,1-.07,1.41Z"
              />
              <rect class="cls-1" width="69.64" height="62.9" />
            </g>
          </svg>
        </div>
        {{ $t('components.email.folders.all_mail') }}
      </div>
      <div
        class="mailtype mailtype-draft"
        :class="[selected_folder == 'drafts' ? 'active' : '']"
        @click="switchMailFolder('drafts')"
        @keydown.enter="switchMailFolder('drafts')"
        @keydown.space.prevent="switchMailFolder('drafts')"
        role="tab"
        tabindex="0"
        :aria-selected="selected_folder == 'drafts'"
        :aria-label="$t('components.email.folders.drafts')"
      >
        <div class="mt draft">
          <svg
            id="Layer_2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 69.64 62.9"
          >
            <defs></defs>
            <g id="Layer_1-2">
              <path
                class="cls-2"
                d="M52.37,37.15c-.55,0-1,.45-1,1v7.03H17.74v-25.75h28.74c.55,0,1-.45,1-1s-.45-1-1-1h-29.74c-.55,0-1,.45-1,1v27.75c0,.55.45,1,1,1h35.63c.55,0,1-.45,1-1v-8.03c0-.55-.45-1-1-1Z"
              />
              <path
                class="cls-2"
                d="M42.33,26.31c0-.55-.45-1-1-1h-18.16c-.55,0-1,.45-1,1s.45,1,1,1h18.16c.55,0,1-.45,1-1Z"
              />
              <path
                class="cls-2"
                d="M37.72,32.35c0-.55-.45-1-1-1h-13.55c-.55,0-1,.45-1,1s.45,1,1,1h13.55c.55,0,1-.45,1-1Z"
              />
              <path
                class="cls-2"
                d="M23.17,37.4c-.55,0-1,.45-1,1s.45,1,1,1h9.58c.55,0,1-.45,1-1s-.45-1-1-1h-9.58Z"
              />
              <path
                class="cls-2"
                d="M58.13,24.37l-2.83-2.83c-.38-.38-1.04-.38-1.41,0l-12.95,12.95c-.11.11-.19.24-.24.38l-1.4,4.07c-.12.35-.04.75.22,1.02.19.2.45.31.72.31.09,0,.19-.01.28-.04l4.23-1.24c.16-.05.31-.13.43-.25l12.95-12.95c.39-.39.39-1.02,0-1.41ZM43.94,37.14l-2.13.62.7-2.02,12.08-12.08,1.42,1.42-12.06,12.06Z"
              />
              <rect class="cls-1" width="69.64" height="62.9" />
            </g>
          </svg>
        </div>
        {{ $t('components.email.folders.drafts') }}
      </div>
      <!-- <div class="mailtype mailtype-sign" @click="openSignature()">
        <div class="mt draft">
          <svg
            fill="#222223"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 512.002 512.002"
            xml:space="preserve"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <g>
                <g>
                  <path
                    d="M509.015,31.078l-28.092-28.09c-3.983-3.983-10.441-3.983-14.425,0l-42.029,42.029l-3.962-3.962 c-3.983-3.983-10.441-3.983-14.425,0L77.96,369.175c-20.562,20.562-36.244,44.762-46.61,71.929l-13.971,36.611 c-0.389,1.019-0.591,2.073-0.644,3.126L2.987,494.59c-3.983,3.983-3.983,10.441,0,14.425c1.992,1.991,4.602,2.986,7.212,2.986 s5.221-0.995,7.212-2.987l13.743-13.743c1.055-0.052,2.111-0.259,3.131-0.648l36.611-13.971 c27.167-10.367,51.367-26.05,71.93-46.611l287.327-287.327c1.899,8.382-3.19,22.793-15.458,35.061l-86.471,86.471 c-3.983,3.983-3.983,10.441,0,14.425c1.992,1.992,4.602,2.987,7.212,2.987c2.61,0,5.221-0.995,7.212-2.987l86.471-86.471 c10.294-10.295,17.555-22.601,20.444-34.653c2.769-11.554,1.226-22.215-4.176-30.067l25.56-25.56 c3.984-3.983,3.984-10.441,0-14.425l-3.962-3.962l42.029-42.029C512.997,41.52,512.997,35.061,509.015,31.078z M128.403,419.616 c-18.518,18.518-40.312,32.641-64.779,41.977l-21.372,8.156l8.156-21.372c9.336-24.466,23.459-46.26,41.977-64.778l11.056-11.055 l36.017,36.017L128.403,419.616z M153.881,394.137l-36.017-36.017l295.43-295.43l36.017,36.018L153.881,394.137z M452.56,73.108 l-13.667-13.667l34.817-34.817l13.667,13.667L452.56,73.108z"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
        {{ $t('components.email.signature') }}
      </div> -->
    </div>
    <div
      class="mailtype mailtype-sync"
      @click="syncFolder()"
      @keydown.enter="syncFolder()"
      @keydown.space.prevent="syncFolder()"
      role="button"
      tabindex="0"
      :aria-label="$t('components.email.folders.sync')"
    >
      <div class="mt sync">
        <svg
          id="Layer_2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 69.64 62.9"
        >
          <defs></defs>
          <g id="Layer_1-2">
            <path
              class="cls-2"
              d="M22.91,27.64h8.12c.58,0,1.04-.44,1.04-.98s-.47-.98-1.04-.98h-5.64c.39-.65.84-1.27,1.38-1.82,2.04-2.08,4.94-3.28,7.95-3.28,4.42,0,8.45,2.58,10.04,6.43.16.39.55.62.97.62.13,0,.25-.02.38-.07.54-.19.81-.76.6-1.26-1.9-4.59-6.72-7.68-11.99-7.68-3.6,0-7.06,1.43-9.5,3.91-.47.48-.89,1-1.27,1.54v-5.34c0-.54-.47-.98-1.04-.98s-1.04.44-1.04.98v7.92c0,.54.47.98,1.04.98Z"
            />
            <path
              class="cls-2"
              d="M46.73,35.25h-8.12c-.58,0-1.04.44-1.04.98s.47.98,1.04.98h5.64c-.39.65-.84,1.27-1.38,1.82-2.04,2.08-4.94,3.28-7.95,3.28-4.42,0-8.45-2.58-10.04-6.43-.21-.5-.81-.75-1.35-.56-.54.19-.81.76-.6,1.26,1.9,4.59,6.72,7.68,11.99,7.68,3.6,0,7.07-1.43,9.5-3.92.47-.48.89-1,1.27-1.54v5.34c0,.54.47.98,1.04.98s1.04-.44,1.04-.98v-7.92c0-.54-.47-.98-1.04-.98Z"
            />
            <rect class="cls-1" width="69.64" height="62.9" />
          </g>
        </svg>
      </div>
      {{ $t('components.email.folders.sync') }}
    </div>
    <email-signature-modal ref="emailSignatureModal"/>
  </div>
</template>

<script>
import EmailSignatureModal from '../../inputs/EmailSignatureModal.vue';
export default {
  components: { EmailSignatureModal },
  props: {
    selected_folder: {
      type: String,
      default: "Inbox",
    },
  },
  methods: {
    switchMailFolder(folder) {
      this.$emit("folderSwitch", folder);
    },
    syncFolder() {
      this.$emit("syncEmails");
    },
    openSignature(){
      this.$refs.emailSignatureModal.open();
    }
  },
};
</script>

<style></style>
